module.exports = __webpack_public_path__ + "img/streamline-icon-apartment@450x450.8ee889a3.svg";